export default [
    {
        key: 'date',
        label: 'field.startDate',
        type: 'year',
        cols: 4,
    },
]
